import styled from 'styled-components';

export const ButtonContainer = styled.div`
  margin: 24px auto 0 auto;
  width: 806px;
  direction: rtl;
`;
